import classNames from 'classnames';
import {h, JSX} from 'preact';

import {CloseIcon, EditIcon} from './Icons';
import {Stack} from './Stack';

export interface OrderSummaryItemProps {
    name: string;
    price: string;
    onEdit?: () => void;
    onRemove?: () => void
}

export const OrderSummaryItem = (props: OrderSummaryItemProps): JSX.Element => (
    <Stack justifyContent='space-between' class='w-full flex justify-between'>
        <div>{props.name}</div>
        <div class='shrink-0 flex self-start'>
            <div
                class={classNames(
                    'font-semibold whitespace-nowrap ml-2 k-body-bold k-nowrap',
                    (props.onEdit || props.onRemove) && 'mr-4'
                )}
            >
                {props.price}
            </div>
            {props.onEdit && (
                <button
                    onClick={props.onEdit}
                    className="-mt-[5px] w-8 h-8 rounded-base hover:bg-icon-button-gray flex items-center justify-center"
                >
                    <EditIcon class="text w-5 h-5"/>
                </button>
            )}
            {props.onRemove && (
                <button
                    onClick={props.onRemove}
                    className="-mt-[5px] w-8 h-8 rounded-base hover:bg-icon-button-gray flex items-center justify-center"
                >
                    <CloseIcon class="text w-5 h-5"/>
                </button>
            )}
        </div>
    </Stack>
);
